import {useEffect, useState} from 'react';
import {firebaseAuth} from '../setup/firebase';
import getAxios from '../util/axios/getAxios';

export interface EnvironmentSecretItem {
  key: string;
  value: string;
}

export default function useEnvironmentSecrets(): {
  data: EnvironmentSecretItem[];
  loading: boolean;
  error: string | undefined;
} {
  const [data, setData] = useState<EnvironmentSecretItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      const token = await firebaseAuth.currentUser?.getIdToken();
      if (!token) {
        if (!cancelled) {
          setError('Not authenticated');
          setLoading(false);
        }
        return;
      }
      try {
        const res = await getAxios('api', {token}).get<EnvironmentSecretItem[]>('environment');
        if (!cancelled) {
          setData(Array.isArray(res.data) ? res.data : []);
          setError(undefined);
        }
      } catch (e) {
        if (!cancelled) {
          const msg =
            e && typeof e === 'object' && 'response' in e
              ? (e as {response?: {data?: {error?: string}}}).response?.data?.error
              : e instanceof Error
                ? e.message
                : 'Failed to load';
          setError(msg ?? undefined);
          setData([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, []);

  return {data, loading, error};
}
